import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../../store'
import { updateTemplate } from '../../../store/templatesUnauthorized/actions'
import { IStore } from '../../../store/types'
import { TamplateForm } from '../../../components/Templates/TamplateForm'
import { ITemplate } from '../../../store/templates/types'
import { TypeTemplates } from '../../../utils/consts'

export const UnauthorizedEditTamplate: React.FC = () => {
  const [template, setTemplate] = React.useState<ITemplate | null>(null)

  const { id } = useParams()

  const { templatesUnauthorized } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (id && templatesUnauthorized.currentGroup) {
      const template = templatesUnauthorized.currentGroup.templates.find((template) => template.absnum === Number(id))
      if (template) {
        setTemplate(template)
      }
    }
  }, [id, templatesUnauthorized.currentGroup])

  const handleCreate = (
    values: { group_id?: number | undefined; product_id: number; message: string },
    callback: (success: boolean) => void
  ) => {
    dispatch(
      updateTemplate({
        id: Number(id),
        data: { ...values, is_type: TypeTemplates.UNAUTHORIZED },
      })
    ).then((res) => {
      if (res.meta.requestStatus !== 'fulfilled') {
        callback(false)
      } else {
        callback(true)
      }
    })
  }

  if (!templatesUnauthorized.currentGroup || !template) return null

  return (
    <TamplateForm
      title={`Група ${templatesUnauthorized.currentGroup.name}. Шаблон`}
      data={template}
      groupId={templatesUnauthorized.currentGroup.absnum}
      createTemplate={handleCreate}
    />
  )
}
